// extracted by mini-css-extract-plugin
module.exports = {"MuiBackdrop-root":"style_MuiBackdrop-root__2l9bl","videosPopupVideo":"style_videosPopupVideo__1pW7d","modal":"style_modal__J8Csd"};